import axios from 'axios';

import { PROVEEDOR } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const buscarProveedores = (filtros) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(filtros);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/proveedores/listar`, body, config);

        await dispatch({
            type: PROVEEDOR.BUSCAR,
            payload: res.data.proveedores
        });
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const limpiarProveedores = () => dispatch => {
    dispatch({
        type: PROVEEDOR.BUSCAR,
        payload: []
    });
}

export const buscarProveedoresTipo = (tipos) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = {
        tipos
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proveedores/listar_tipo`, body, config);

        await dispatch({
            type: PROVEEDOR.BUSCAR,
            payload: res.data.proveedores
        });
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const crearProveedor = (proveedor) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(proveedor);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proveedores/crear`, body, config);

        await dispatch({
            type: PROVEEDOR.AGREGAR,
            payload: res.data.proveedor
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const obtenerProveedor = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proveedores/detalles`, body, config);

        await dispatch({
            type: PROVEEDOR.DETALLES,
            payload: res.data.proveedor
        });
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const limpiarProveedor = () => dispatch => {
    dispatch({
        type: PROVEEDOR.DETALLES,
        payload: null
    });
}

export const editarProveedor = (proveedor) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(proveedor);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proveedores/editar`, body, config);

        await dispatch({
            type: PROVEEDOR.EDITAR,
            payload: res.data.proveedor
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const eliminarProveedor = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proveedores/eliminar`, body, config);

        await dispatch({
            type: PROVEEDOR.ELIMINAR,
            payload: body
        });
        
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){        
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const filtarProveedores = (opcion) => dispatch => {
    dispatch({
        type: PROVEEDOR.FILTROS,
        payload: opcion
    });
}

//Productos
// Listar productos de un proveedor
export const buscarProductosProveedor = (id_proveedor, filtros = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const bodyBack = {
        id_proveedor,
        nombre: filtros.nombre ?? null,
        id_categoria: filtros.id_categoria ?? filtros.categoria ?? null,
        id_subcategoria: filtros.id_subcategoria ?? filtros.subcategoria ?? null,
        codigo: filtros.codigo ?? null,
        codigo_proveedor: filtros.codigo_proveedor ?? null
    };

    try {
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/proveedores/listar_productos`,
            bodyBack,
            config
        );

        await dispatch({
            type: PROVEEDOR.PRODUCTOS_BUSCAR,
            payload: res.data.productos
        });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
};

export const crearProductoProveedor = (datos) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify(datos); // datos debe traer id_proveedor

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/proveedores/crear_producto`,
            body,
            config
        );
        await dispatch(changeLoader(false));

        // 🔑 DESPUÉS DE CREAR, RECARGA EL LISTADO DEL MISMO PROVEEDOR
        if (datos.id_proveedor) {
            await dispatch(buscarProductosProveedor(datos.id_proveedor));
        }

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        await dispatch(changeLoader(false));
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    }
};

export const obtenerProductoProveedor = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = { id };

    try {
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/proveedores/detalles_producto`,
            body,
            config
        );

        await dispatch({
            type: PROVEEDOR.PRODUCTOS_DETALLES,
            payload: res.data.producto,   // viene con _id, id_producto, id_proveedor, etc.
        });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    }
};

export const limpiarProductoProveedor = () => dispatch => {
    dispatch({
        type: PROVEEDOR.PRODUCTOS_DETALLES,
        payload: null,
    });
};

export const editarProductoProveedor = (producto) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    // Armamos el body que espera el backend
    const body = JSON.stringify({
        id:                producto._id,                 // id del registro proveedor-producto
        id_proveedor:      producto.id_proveedor,        // para seguridad y para recargar
        id_producto:       producto.id_producto,         // por si el back lo valida
        codigo_tienda:     producto.codigo_tienda,
        codigo_proveedor:  producto.codigo_proveedor,
        precio_publico:    producto.precio_publico,
        precio_minimo:     producto.precio_minimo,
        precio_liquidacion: producto.precio_liquidacion,
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/proveedores/editar_producto`,
            body,
            config
        );
        await dispatch(changeLoader(false));

        // 1) actualizas el detalle en redux (por si alguien lo usa)
        await dispatch({
            type: PROVEEDOR.PRODUCTOS_EDITAR,
            payload: {
                ...producto,
            },
        });

        // 2) recargas el listado para ese proveedor (lo importante para la tabla)
        if (producto.id_proveedor) {
            await dispatch(buscarProductosProveedor(producto.id_proveedor));
        }

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        await dispatch(changeLoader(false));
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    }
};

export const eliminarProductoProveedor = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = { id };

    try {
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/proveedores/eliminar_producto`,
            body,
            config
        );

        await dispatch({
            type: PROVEEDOR.PRODUCTOS_ELIMINAR,
            payload: id
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    }
};

/* Ajusta por porcentaje (incremento | decremento) los 3 precios de TODOS los productos
   de un proveedor de una sola vez. porcentaje_* son opcionales e independientes entre sí
   (el backend solo ajusta los que vengan distintos de 0). */
export const ajustarPreciosProveedor = (id_proveedor, { tipo, porcentaje_publico, porcentaje_minimo, porcentaje_liquidacion }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id_proveedor,
        tipo,
        porcentaje_publico: porcentaje_publico || null,
        porcentaje_minimo: porcentaje_minimo || null,
        porcentaje_liquidacion: porcentaje_liquidacion || null
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/proveedores/ajustar_precios`,
            body,
            config
        );
        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            await dispatch(setAlert(res.data?.msg || 'No se pudieron ajustar los precios', 'danger'));
            return false;
        }

        await dispatch(buscarProductosProveedor(id_proveedor));
        await dispatch(setAlert(res.data?.msg || 'Precios ajustados correctamente', 'success'));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch(setAlert(error?.response?.data?.msg || 'Error al ajustar los precios', 'danger'));
        return false;
    }
};





